import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import UserService from '../../../services/user.service';
import * as log from '../../../utils/log';
import { connectWallet } from '../Wallet/slice';
import { InitialMetaData } from '../../constants/constants';
export const getNotifications = createAsyncThunk('notifications/pages', async ({ page, limit }) => {
    try {
        return await UserService.getNotifications({ page, limit });
    }
    catch (err) {
        return err.response;
    }
});
export const getNotification = createAsyncThunk('notifications/', async (notificationId) => {
    try {
        return await UserService.getNotification(notificationId);
    }
    catch (err) {
        return err.response;
    }
});
export const filterNotifications = createAsyncThunk('notifications?date', async ({ page, limit, date }) => {
    try {
        return await UserService.filterNotificationByDateWithPages(date, page, limit);
    }
    catch (err) {
        if (axios.isAxiosError(err)) {
            return err.response;
        }
    }
});
export const markAsRead = createAsyncThunk('notifications/read', async (data) => {
    try {
        return await UserService.markAsRead(data);
    }
    catch (err) {
        if (axios.isAxiosError(err)) {
            return err.response;
        }
    }
});
export var NOTIFICATION_TYPE;
(function (NOTIFICATION_TYPE) {
    NOTIFICATION_TYPE["NEW_INVITATION"] = "new_invitation";
    NOTIFICATION_TYPE["GUILD_REQUEST"] = "guild_request";
    NOTIFICATION_TYPE["GUILD_ANSWER"] = "guild_answer";
    NOTIFICATION_TYPE["GUILD_ACTION"] = "guild_action";
    NOTIFICATION_TYPE["USER_ACTION"] = "user_action";
    NOTIFICATION_TYPE["ACTIVATED"] = "activated";
    NOTIFICATION_TYPE["DELETED"] = "deleted";
})(NOTIFICATION_TYPE || (NOTIFICATION_TYPE = {}));
export var REQUEST_STATUS;
(function (REQUEST_STATUS) {
    REQUEST_STATUS["PENDING"] = "pending";
    REQUEST_STATUS["ACCEPTED"] = "accepted";
    REQUEST_STATUS["DECLINED"] = "declined";
    REQUEST_STATUS["CANCELED"] = "canceled";
})(REQUEST_STATUS || (REQUEST_STATUS = {}));
export var GUILD_LOG_TYPE;
(function (GUILD_LOG_TYPE) {
    GUILD_LOG_TYPE["ASSIGNEE_ADMIN"] = "Assignee-admin";
    GUILD_LOG_TYPE["REVOKE_ADMIN"] = "Revoke-admin";
    GUILD_LOG_TYPE["DELETE_USER"] = "Delete-user";
    GUILD_LOG_TYPE["BAN_USER"] = "Ban-user";
    GUILD_LOG_TYPE["UNBAN_USER"] = "Unban-user";
})(GUILD_LOG_TYPE || (GUILD_LOG_TYPE = {}));
export var ACTIVITY_TYPE;
(function (ACTIVITY_TYPE) {
    ACTIVITY_TYPE["WALLET"] = "Wallet";
    ACTIVITY_TYPE["CHAT"] = "Chat";
    ACTIVITY_TYPE["SIGN_IN"] = "Sign-in";
    ACTIVITY_TYPE["REMOVE_FRIEND"] = "Remove-friend";
    ACTIVITY_TYPE["ACTIVATED"] = "Activated";
    ACTIVITY_TYPE["BANNED"] = "Banned";
    ACTIVITY_TYPE["BLOCKED"] = "Blocked";
    ACTIVITY_TYPE["UNBANNED"] = "Unbanned";
    ACTIVITY_TYPE["UNBLOCKED"] = "Unblocked";
    ACTIVITY_TYPE["DELETED"] = "Deleted";
    ACTIVITY_TYPE["ALL"] = "All";
})(ACTIVITY_TYPE || (ACTIVITY_TYPE = {}));
export const initialState = {
    userNotifications: [],
    metaData: InitialMetaData,
    isLoading: false,
    needGetNotificationList: true,
    limit: 20
};
const setUserNotifications = (state, action) => {
    state.isLoading = false;
    state.needGetNotificationList = false;
    if (action.payload.status === 200 && action.payload) {
        state.metaData = action.payload.data.metadata;
        const ids = state.userNotifications.map(({ id }) => id);
        state.userNotifications.push(...action.payload.data.data.filter(({ id }) => !ids.includes(id)));
    }
    if (action.payload.status !== 200) {
        log.error(action);
    }
};
const setUserNotificationsFiltered = (state, action) => {
    state.isLoading = false;
    state.needGetNotificationList = false;
    if (action.payload.status === 200 && action.payload) {
        state.metaData = action.payload.data.metadata;
        state.userNotifications = action.payload.data.data;
    }
    if (action.payload.status !== 200) {
        log.error(action);
    }
};
export const slice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        addNewNotification: (state, action) => {
            state.userNotifications.unshift(action.payload);
        },
        clearNotificationData: (state) => {
            state.userNotifications = [];
            state.needGetNotificationList = true;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getNotifications.fulfilled, setUserNotifications);
        builder.addCase(filterNotifications.fulfilled, setUserNotificationsFiltered);
        builder.addCase(markAsRead.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                const newNotifications = action.payload.data;
                state.userNotifications = state.userNotifications.map((notification) => {
                    const newNotification = newNotifications.find((item) => item.id === notification.id);
                    return newNotification ? newNotification : notification;
                });
            }
        });
        builder.addCase(getNotification.fulfilled, (state, action) => {
            state.isLoading = false;
            if (action.payload.status === 200) {
                const notification = action.payload.data;
                state.userNotifications = state.userNotifications.map((userNotification) => userNotification.id === notification.id ? notification : userNotification);
            }
        });
        builder.addCase(getNotification.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getNotification.rejected, (state) => {
            state.isLoading = false;
        });
        builder.addCase(getNotifications.pending, (state) => {
            state.isLoading = true;
            state.needGetNotificationList = false;
        });
        builder.addCase(getNotifications.rejected, (state) => {
            state.isLoading = false;
        });
        builder.addCase(filterNotifications.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(filterNotifications.rejected, (state) => {
            state.isLoading = false;
        });
        builder.addCase(connectWallet.fulfilled, (state, action) => {
            state.userNotifications = [];
            state.metaData = InitialMetaData;
            state.needGetNotificationList = true;
        });
    }
});
export const { addNewNotification, clearNotificationData } = slice.actions;
export default slice.reducer;
